<h2 mat-dialog-title class="dialog-title">
  <mat-icon color="gray">{{ isEdit ? 'edit' : 'add_circle' }}</mat-icon>
  {{ isEdit ? 'Coin bearbeiten' : 'Neuen Coin anlegen' }}
</h2>
<form [formGroup]="addCoinTypeForm" (ngSubmit)="submit()" mat-dialog-content>
  <section class="cointype-section">
    <div class="section-title">Coin Wert</div>
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Wert (in Euro)</mat-label>
      <input matInput type="number" formControlName="value" required />
      <span matSuffix style="margin-right: 20px">€</span>
    </mat-form-field>
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Grundbetrag (Coins pro 1000€)</mat-label>
      <input matInput type="number" formControlName="baseAmount" required />
      <span matSuffix style="margin-right: 20px">Coins</span>
    </mat-form-field>
  </section>

  <section class="tiers-section">
    <div class="tiers-header">
      <div>
        <span class="section-title">Staffelungen</span>
        <p class="section-description">Definiere Umsatzstufen und deren Bonusregelungen</p>
      </div>
      <button mat-fab extended color="primary" type="button" (click)="addTier()" class="apple-button apple-button-primary"  style="font-size: 15px; color: white; display: flex; flex-direction: row;">
          <mat-icon style="margin-top: 5px;">add</mat-icon>
        Staffelung hinzufügen
      </button>
    </div>
    
    <div formArrayName="tiers" class="tiers-list">
      <div *ngIf="tiers.length > 0" class="tiers-table">
        <div class="tiers-table-header">
          <div class="tier-col tier-col-badge">Stufe</div>
          <div class="tier-col tier-col-range">Umsatzbereich</div>
          <div class="tier-col tier-col-bonus">Einmalbonus</div>
          <div class="tier-col tier-col-gain">Coins pro 1000€</div>
          <div class="tier-col tier-col-actions"></div>
        </div>
        
        <div *ngFor="let tier of tiers.controls; let i = index" [formGroupName]="i" class="tier-row">
          <div class="tier-col tier-col-badge">
            <div class="tier-badge">{{ i + 1 }}</div>
          </div>
          
          <div class="tier-col tier-col-range">
            <div class="range-display">
              <mat-form-field appearance="outline" class="range-input">
                <mat-label>Von</mat-label>
                <input matInput type="number" [value]="getTierMinimum(i)" disabled />
                <span matSuffix>€</span>
              </mat-form-field>
              <span class="range-separator">–</span>
              <mat-form-field appearance="outline" class="range-input">
                <mat-label>Bis</mat-label>
                <input matInput type="number" formControlName="breakPoint" required min="1" (input)="onTierBreakPointChange()" />
                <span matSuffix>€</span>
              </mat-form-field>
            </div>
          </div>
          
          <div class="tier-col tier-col-bonus">
            <mat-form-field appearance="outline" class="compact-field">
              <mat-label>Bonuscoins</mat-label>
              <input matInput type="number" formControlName="bonusAmount" required min="1" />
            </mat-form-field>
          </div>
          
          <div class="tier-col tier-col-gain">
            <mat-form-field appearance="outline" class="compact-field">
              <mat-label>Coins</mat-label>
              <input matInput type="number" formControlName="coinGain" required min="0" />
            </mat-form-field>
          </div>
          
          <div class="tier-col tier-col-actions">
            <button mat-icon-button color="warn" type="button" (click)="removeTier(i)" aria-label="Tier entfernen">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
      
      <div *ngIf="tiers.length === 0" class="empty-state">
        <mat-icon>info</mat-icon>
        <p>Noch keine Staffelungen definiert. Füge deine erste Staffelung hinzu.</p>
      </div>
    </div>
  </section>

  <div mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button mat-dialog-close type="button">Abbrechen</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="addCoinTypeForm.invalid || tiers.length === 0">
      {{ isEdit ? 'Speichern' : 'Anlegen' }}
    </button>
  </div>
</form>
